// No sale is running. To run one, set this to its end date, matching the automatic discount in Shopify.
const SALE_END = 0;

function applySale() {
  const remaining = SALE_END - Date.now();
  document.documentElement.classList.toggle('sol-sale-ended', remaining <= 0);
  document.querySelectorAll('[data-timer]').forEach((timer) => {
    const left = Math.max(remaining, 0) / 1000;
    const pad = (value) => String(Math.floor(value)).padStart(2, '0');
    timer.textContent = `${pad(left / 86400)}d ${pad((left % 86400) / 3600)}:${pad((left % 3600) / 60)}:${pad(left % 60)}`;
  });
}
applySale();
setInterval(applySale, 1000);

function initGallery(root) {
  const slides = root.querySelector('[data-slides]');
  const thumbs = [...root.querySelectorAll('[data-thumb]')];
  if (!slides) return { showColour() {} };
  const items = [...slides.children];
  const visible = () => items.filter((item) => !item.hidden);
  const markThumb = (active) => {
    thumbs.forEach((thumb, index) => thumb.setAttribute('aria-current', String(items[index] === active)));
  };
  const show = (index, behavior = 'smooth') => {
    const shown = visible();
    const target = ((index % shown.length) + shown.length) % shown.length;
    slides.scrollTo({ left: slides.clientWidth * target, behavior });
    markThumb(shown[target]);
  };
  const current = () => Math.round(slides.scrollLeft / Math.max(slides.clientWidth, 1));
  root.querySelectorAll('[data-step]').forEach((arrow) => {
    arrow.addEventListener('click', () => show(current() + Number(arrow.dataset.step)));
  });
  thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(visible().indexOf(items[index]))));
  slides.addEventListener('scroll', () => markThumb(visible()[current()]), { passive: true });
  return {
    // Only the chosen colour's main photo stays in the carousel, as its first slide.
    showColour(colour, behavior) {
      if (!items.some((item) => item.dataset.colour === colour)) return;
      items.forEach((item, index) => {
        if (!item.dataset.colour) return;
        item.hidden = item.dataset.colour !== colour;
        thumbs[index].hidden = item.hidden;
      });
      show(0, behavior);
    },
  };
}

async function addToCart(form, button, errorEl) {
  const data = new FormData(form);
  const quantity = Number(data.get('quantity'));
  const variantId = String(data.get('id'));
  const sectionIds = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
  // On the insole page, 3 pairs also adds the roller, which an automatic discount makes free. The kit product already includes it.
  const isKitPage = location.pathname.includes('/products/full-foot-kit');
  const rollerId = quantity === 3 && !isKitPage ? form.dataset.rollerId : '';
  const lines = [{ merchandiseId: variantId, quantity }];
  if (rollerId) lines.push({ merchandiseId: rollerId, quantity: 1 });
  if (sectionIds.length) data.append('sections', sectionIds.join(','));
  const { CartLinesUpdateEvent } = await import('@shopify/events');
  const deferred = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines, promise: deferred.promise }));
  const request = rollerId
    ? {
        headers: { Accept: 'text/html', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: lines.map((line) => ({ id: Number(line.merchandiseId), quantity: line.quantity })),
          sections: sectionIds.join(','),
        }),
      }
    : { headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }, body: data };
  const response = await fetch(Theme.routes.cart_add_url, { method: 'POST', ...request }).then((res) => res.json());
  if (response.status) {
    deferred.reject(new DOMException('Add failed', 'AbortError'));
    errorEl.textContent = response.description || response.message || 'Could not add to cart. Please try again.';
    errorEl.hidden = false;
    return;
  }
  const cart = await fetch('/cart.js').then((res) => res.json());
  deferred.resolve({
    cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
    detail: {
      items: cart.items,
      source: 'product-form-component',
      sourceId: form.id,
      itemCount: quantity,
      productId: form.dataset.productId,
      sections: response.sections,
      didError: false,
    },
  });
  document.getElementById('cart-drawer')?.open?.();
}

function initProduct(root) {
  const gallery = initGallery(root);
  const form = root.querySelector('[data-form]');
  const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
  const idInput = form.querySelector('input[name="id"]');
  const quantityInput = form.querySelector('input[name="quantity"]');
  const button = form.querySelector('[data-add]');
  const errorEl = form.querySelector('[data-error]');
  const label = button.textContent;

  const checked = (name) => form.querySelector(`input[name="${name}"]:checked`)?.value;
  const syncVariant = () => {
    if (!checked('Size')) {
      button.textContent = 'Select shoe size';
      return;
    }
    const colour = checked('Colour');
    const variant = variants.find((item) => item.option1 === colour && item.option2 === checked('Size'));
    button.disabled = !variant?.available;
    button.textContent = variant?.available ? label : 'Sold out';
    if (!variant) return;
    idInput.value = variant.id;
    const url = new URL(location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState(null, '', url);
  };
  form.querySelectorAll('input[name="Colour"]').forEach((input) => input.addEventListener('change', () => {
    form.querySelector('[data-colour-name]').textContent = input.value;
    gallery.showColour(input.value);
    syncVariant();
  }));
  form.querySelectorAll('input[name="Size"]').forEach((input) => input.addEventListener('change', syncVariant));

  const pairs = [...form.querySelectorAll('input[name="sol_pairs"]')];
  pairs.forEach((input) => input.addEventListener('change', () => { quantityInput.value = input.value; }));
  const params = new URLSearchParams(location.search);
  const start = pairs.find((input) => input.value === params.get('pairs'));
  if (start) { start.checked = true; quantityInput.value = start.value; }

  const colourInput = [...form.querySelectorAll('input[name="Colour"]')].find((input) => input.value === params.get('colour'));
  if (colourInput) {
    colourInput.checked = true;
    form.querySelector('[data-colour-name]').textContent = colourInput.value;
  }
  if (colourInput || params.has('variant')) gallery.showColour(checked('Colour'), 'auto');
  syncVariant();

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    errorEl.hidden = true;
    if (!checked('Size')) {
      errorEl.textContent = 'Please select your shoe size.';
      errorEl.hidden = false;
      form.querySelector('.sol-sizes').scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }
    button.disabled = true;
    try {
      await addToCart(form, button, errorEl);
    } catch (error) {
      console.error(error);
      if (form.dataset.rollerId && quantityInput.value === '3' && !location.pathname.includes('/products/full-foot-kit')) {
        errorEl.textContent = 'Could not add to cart. Please try again.';
        errorEl.hidden = false;
      } else {
        form.submit();
      }
    } finally {
      button.disabled = false;
    }
  });
}

const productRoot = document.querySelector('[data-sol-product]');
if (productRoot) initProduct(productRoot);
